import { CloseOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { Badge, Button, Col, Form, Image, Input, InputNumber, Row, Select, Spin, Upload } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import addOnService from '../../../../services/config/add_on.service';
import RichTextEditor from '../../../../helpers/components/rich_text_editor';

const { TextArea } = Input;
const EditAddOnModal = ({ form, add_on_id, modal, }) => {
    const [state, setState] = useState({
        loading : false,
        image : null,
        add_on : null,
        add_on_types : [],
        add_on_sections : [],

        // add on section
        selected_add_on_section : null,
        // delete image
        is_delete_image : false,
    });

    const is_generate_code = useMemo(() => {
        return state?.selected_add_on_section?.is_generate_code;
    }, [state?.selected_add_on_section])

    const removeImage = async () => {
        form.setFieldsValue({ image : null, is_delete_image : true, });

        setState(state => ({...state, image : null, is_delete_image : true, }));
    }
    
    const acceptable_file_format = ['image/jpeg', 'image/png'];
    const beforeUpload = async (file) => {
        const is_image = acceptable_file_format?.find(x => x == file?.type);

        if(is_image){
            const uploaded_file = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    file.base64 = reader.result.split(',')[1];
                    resolve(file);
                };
                reader.onerror = (error) => reject(error);
            });
    
            const base64Image = `data:image/jpeg;base64,${uploaded_file?.base64}`;

            form.setFieldsValue({ is_delete_image : false, });
            setState(state => ({...state, image : base64Image, is_delete_image : false, }));
        }else{
            // errorModal("Please upload in image format");
        }
        return false;
    }

    const fetchAddOn = async () => {
        const addOnResponse = await addOnService?.fetchAddOn({
            add_on_id : add_on_id,
        })

        const { add_ons } = addOnResponse;
        const add_on = add_ons?.[0];
        return add_on;
    }

    const fetchAddOnTypes = async () => {
        const addOnTypeResponse = await addOnService?.fetchAddOnType();

        const { add_on_types } = addOnTypeResponse;
        return add_on_types;
    }

    const onDeltaChange = (html) => {
        form.setFieldsValue({ description : html || null, });
    }

    const fetchAddOnSections = async () => {
        const addOnSectionResponse = await addOnService?.fetchAddOnSection();
        
        const { add_on_sections = [], } = addOnSectionResponse;
        return add_on_sections;
    }

    const initialize = async () => {
        setState(state => ({...state, loading : true,}));

        const add_on = await fetchAddOn();
        const add_on_types = await fetchAddOnTypes();
        const add_on_sections = await fetchAddOnSections();
        
        setState(state => ({...state, loading : false, selected_add_on_section : add_on?.add_on_section, add_on : add_on, add_on_types : add_on_types, add_on_sections : add_on_sections, image : add_on?.image, }));
        


        if(add_on){
            const { name, description, add_on_type_id, add_on_section_id, reference_quantity, } = add_on;
            form.setFieldsValue({ name, add_on_type_id, add_on_section_id, reference_quantity, description : description || null, });
        }
    }

    useEffect(() => {
        initialize();
    }, [add_on_id, modal])

    return (
        <>
            <Spin spinning={state?.loading} indicator={<LoadingOutlined />}>
                <Form.Item
                label={"Image"}
                style={{ textAlign : 'start', marginBottom : 0, }}
                >
                    <Badge offset={[-8, 4]} count={(
                        <Button
                        onClick={removeImage}
                        icon={<CloseOutlined />}
                        size='small'>
                        </Button>
                    )}>
                        <Form.Item name={'is_delete_image'} hidden></Form.Item>
                        <Form.Item name={'image'}>
                            <Upload
                            name="company_logo"
                            listType='picture-card'
                            beforeUpload={beforeUpload}
                            showUploadList={false}
                            style={{width : '100%',}}
                            >
                                {
                                    state?.image ?
                                    (
                                        <>
                                            <Image preview={false} src={state?.image} style={{ maxWidth : '100%', maxHeight : 102, objectFit : 'contain', }} />
                                        </>
                                    )
                                    :
                                    (
                                        <>
                                            <div>
                                                <div>
                                                    <PlusOutlined />
                                                </div>
                                                <div>Upload</div>
                                            </div>
                                        </>
                                    )
                                }
                            </Upload>
                        </Form.Item>
                    </Badge>
                </Form.Item>

                <Form.Item label={"Name"} name={'name'}>
                    <Input />
                </Form.Item>

                <Form.Item name="description" hidden>
                    <Input type="hidden" />
                </Form.Item>

                
                <Form.Item
                label={"Description"}
                >
                    <RichTextEditor
                    placeholder='Enter descriptions'
                    onChange={onDeltaChange}
                    value={state?.add_on?.description}
                    />
                </Form.Item>

                <Form.Item label={"Add On Type"} name={'add_on_type_id'}>
                    <Select
                    placeholder={"Select Add On Type"}
                    allowClear
                    options={state?.add_on_types?.map(x => ({ label : x?.name, value : x?.add_on_type_id, }))}
                    />
                </Form.Item>

                <Row gutter={[12, 12]}>
                    <Col span={12}>
                        <Form.Item label={"Add On Section"} name={'add_on_section_id'}>
                            <Select
                            onChange={(x, k) => setState(state => ({...state, selected_add_on_section : k, }))}
                            placeholder={"Select Add On Section"}
                            allowClear
                            options={state?.add_on_sections?.map(x => ({ label : x?.name, value : x?.add_on_section_id, is_generate_code : x?.is_generate_code, }))}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label={"Reference Value"} name={'reference_quantity'}>
                            <InputNumber disabled={!is_generate_code} style={{ width : '100%', }} />
                        </Form.Item>
                    </Col>
                </Row>
            </Spin>
        </>
    );
}

export default EditAddOnModal;